<template>
  <div class="main-agent-list">
    <el-row>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline search-form"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model="searchForm.username"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            clearable
            v-model="searchForm.agentId"
            placeholder="所属合作机构"
          >
            <el-option
              v-for="item in agentList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearchUser" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCreateUser" icon="el-icon-plus"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        row-key="id"
        stripe
        style="width: 100%"
      >
        <el-table-column prop="username" label="用户名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="agentName"
          label="所属合作机构"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="初始密码" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="重置密码为000000"
              placement="top-start"
            >
              <el-button
                round
                type="text"
                size="mini"
                @click="onResetPassword(scope.row)"
                >重置</el-button
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="权限管理" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onUpResource(scope.row)"
              >功能权限</el-button
            >
            <!--<el-button type="text" size="small" @click="onUpProject(scope.row)"-->
            <!--&gt;数据权限</el-button-->
            <!--&gt;-->
            <el-button
              type="text"
              size="small"
              @click="onUpDataPermission(scope.row)"
              >数据权限</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onDelete(scope.row)"
              >删除用户</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="tableTotal"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      @current-change="onCurrentPageChange"
      align="center"
    >
    </el-pagination>

    <el-dialog
      title="创建用户"
      :visible.sync="dialogFormVisible"
      width="35%"
      :show-close="false"
    >
      <agent-user-edit
        v-if="dialogFormVisible"
        :is-edit="isFormEdit"
        :editForm="editForm"
        @onCancle="editCancle"
        @onSaveSuccess="onSaved"
      ></agent-user-edit>
    </el-dialog>

    <el-dialog
      title="设置功能权限"
      destroy-on-close
      :visible.sync="dialogResourceVisible"
      :show-close="false"
      :lock-scroll="true"
    >
      <agent-user-resources
        v-if="dialogResourceVisible"
        :user-id="currentUserId"
        @on-cancel="onResourceWindownClose"
      />
    </el-dialog>

    <el-dialog
      title="设置项目权限"
      destroy-on-close
      :visible.sync="dialogProjectVisible"
      :show-close="false"
      :lock-scroll="true"
    >
      <agent-user-projects
        v-if="dialogProjectVisible"
        :user-id="currentUserId"
        @on-cancel="onProjectWindownClose"
      />
    </el-dialog>

    <el-dialog
      title="设置数据权限"
      destroy-on-close
      :visible.sync="dialogDataPermissionVisible"
      :show-close="false"
      :lock-scroll="true"
    >
      <agent-user-data-permission
        v-if="dialogDataPermissionVisible"
        :user-id="currentUserId"
        :agent-id="currentAgentId"
        @on-cancel="onDataPermissionWindownClose"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  getAgentUsers,
  deleteAgentUser,
  resetAgentUserPassword,
  viewAgentUserPassword
} from "@/api/agentUser";
import { getAgentList } from "@/api/agentInfo";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import AgentUserEdit from "./AgentUserEdit";
import AgentUserResources from "./AgentUserResources";
import AgentUserProjects from "./AgentUserProjects";
import AgentUserDataPermission from "./AgentUserDataPermission";

export default {
  name: "agentUser",
  components: {
    AgentUserProjects,
    AgentUserEdit,
    AgentUserResources,
    AgentUserDataPermission
  },
  directives: { permission },
  data: function() {
    return {
      searchForm: {
        username: null,
        agentId: null
      },
      tableData: [],
      currentPage: 1,
      tableTotal: -1,
      tablePages: 0,
      loading: false,
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      dialogFormVisible: false,
      dialogResourceVisible: false,
      dialogProjectVisible: false,
      dialogDataPermissionVisible: false,
      tableLoading: false,
      isFormEdit: false,
      editForm: null,
      currentUserId: null,
      currentAgentId: null,
      agentList: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.loadUsers();
    this.getAgentList();
  },
  methods: {
    onUpResource: function(data) {
      this.currentUserId = data.agentUserId;
      this.dialogResourceVisible = true;
    },
    onUpProject: function(data) {
      this.currentUserId = data.agentUserId;
      this.dialogProjectVisible = true;
    },
    onUpDataPermission: function(data) {
      this.currentUserId = data.agentUserId;
      this.currentAgentId = data.agentId;
      this.dialogDataPermissionVisible = true;
    },
    onDelete: function(data) {
      let that = this;
      that
        .$confirm("用户删除后将无法恢复，确认删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          deleteAgentUser(data.agentUserId).then(res => {
            if (res && res.code === "200") {
              that.$message.success("删除成功");
              that.loadUsers();
            }
          });
        })
        .catch(() => {});
    },
    onViewPassword: function(data) {
      let that = this;
      viewAgentUserPassword(data.agentUserId).then(res => {
        if (res && res.code === "200") {
          that.$alert(res.data);
        }
      });
    },
    onResetPassword: function(data) {
      let that = this;
      that
        .$confirm("密码将被初始化为000000，确定要操作吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          resetAgentUserPassword(data.agentUserId).then(res => {
            if (res && res.code === "200") {
              that.$message.success("重置成功");
            }
          });
        })
        .catch(() => {});
    },
    onResourceWindownClose: function() {
      this.dialogResourceVisible = false;
    },
    onProjectWindownClose: function() {
      this.dialogProjectVisible = false;
    },
    onDataPermissionWindownClose: function() {
      this.dialogDataPermissionVisible = false;
    },
    getAgentList() {
      let that = this;
      getAgentList().then(res => {
        if (res && res.code === "200") {
          res.data.map(item => {
            that.agentList.push({
              label: item.agentName,
              value: item.agentId
            });
          });
        }
      });
    },
    onSearchUser: function() {
      this.currentPage = 1;
      this.loadUsers();
    },
    onCreateUser: function() {
      this.isFormEdit = false;
      this.editForm = null;
      this.dialogFormVisible = true;
    },
    loadUsers() {
      let self = this;
      this.tableLoading = true;
      getAgentUsers({
        username: this.searchForm.username,
        agentId: this.searchForm.agentId,
        page: this.currentPage,
        pageSize: defaultPageConfig.pageSize
      })
        .then(res => {
          if (res && res.data) {
            self.tableTotal = Number(res.data.total);
            self.tablePages = res.data.pages;
            self.tableData = res.data.list;
          } else {
            self.tableTotal = 0;
            self.tablePages = 0;
            self.tableData = [];
          }
        })
        .finally(() => {
          self.tableLoading = false;
        });
    },
    editCancle: function() {
      this.dialogFormVisible = false;
    },
    onSaved: function() {
      this.loadUsers();
    },
    onCurrentPageChange: function(page) {
      this.currentPage = page;
      this.loadUsers();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-agent-list {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 84px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
  }
}
</style>
